module.exports = __webpack_public_path__ + "static/media/Rishi.14285fc7.png";